import React from "react";

const SoftwareUpgradeTable = () => {
  const headers = ["Part #", "Type", "Description", "List", "Suggested"];
  const rows = [
    {
      part: "e3UServer",
      type: "Software Utility and Upgrade",
      desc: "Converts e3 Hardware to operate Neptune 2.0 Software – applies same model capabilities. Example: Essentials = Advantage, Elite to Professional.",
      list: "Please call",
      suggested: "Please call",
    },
    {
      part: "Se3UClient",
      type: "Software Utility and Upgrade",
      desc: "Converts e3 Hardware to operate Neptune 2.0 Client",
      list: "Please call",
      suggested: "Please call",
    },
  ];
  const notes = [
    "Note: The new software gives you the ability to switch from a client to server.",
    "All hardware upgraded with the client option for multi-role, but the upgraded devices still require configuration for the new access control features.",
  ];

  return (
    <div className="w-full ">
      <div className="hidden lg:grid grid-cols-5 border border-[#777980]">
        {headers.map((header, idx) => (
          <div
            key={idx}
            className="p-3 font-[Poppins] text-white text-center bg-[#0D0D0D] text-[16px] border border-[#777980]"
          >
            {header}
          </div>
        ))}
        {rows.map((row, rowIdx) => (
          <React.Fragment key={rowIdx}>
            <div className="p-3 text-[#4A4C56] text-[13px] font-[Poppins] text-center border border-[#777980]">
              {row.part}
            </div>
            <div className="p-3 text-[#4A4C56] text-[13px] font-[Poppins] text-center border border-[#777980]">
              {row.type}
            </div>
            <div className="p-3 text-[#4A4C56] text-[13px] font-[Poppins] text-center border border-[#777980]">
              {row.desc}
            </div>
            <div className="p-3 text-[#4A4C56] text-[13px] font-[Poppins] text-center border border-[#777980]">
              {row.list}
            </div>
            <div className="p-3 text-[#4A4C56] text-[13px] font-[Poppins] text-center border border-[#777980]">
              {row.suggested}
            </div>
          </React.Fragment>
        ))}
        {notes.map((note, idx) => (
          <div
            key={`note-${idx}`}
            className="p-3 text-[#4A4C56] text-[13px] font-[Poppins] border border-[#777980] text-center col-span-5"
          >
            {note}
          </div>
        ))}
      </div>

      {/* Responsive for small devices */}
      <div className="lg:hidden flex flex-col gap-2">
        {[...rows, ...notes.map((n) => ({ note: n }))].map((item, i) => (
          <div key={i} className="border border-[#777980] rounded-md">
            {item.note ? (
              <div className="p-3 text-[#4A4C56] text-[13px] font-[Poppins]">
                {item.note}
              </div>
            ) : (
              <>
                <div className="flex border-b border-[#777980]">
                  <div className="w-1/3 p-2 bg-[#0D0D0D] text-white text-[13px] text-center font-[Poppins] border-r border-[#777980]">
                    Part #
                  </div>
                  <div className="w-2/3 p-2 text-[#4A4C56] text-[13px] font-[Poppins]">
                    {item.part}
                  </div>
                </div>
                <div className="flex border-b border-[#777980]">
                  <div className="w-1/3 p-2 bg-[#0D0D0D] text-white text-[13px] text-center font-[Poppins] border-r border-[#777980]">
                    Type
                  </div>
                  <div className="w-2/3 p-2 text-[#4A4C56] text-[13px] font-[Poppins]">
                    {item.type}
                  </div>
                </div>
                <div className="flex border-b border-[#777980]">
                  <div className="w-1/3 p-2 bg-[#0D0D0D] text-white text-[13px] text-center font-[Poppins] border-r border-[#777980]">
                    Description
                  </div>
                  <div className="w-2/3 p-2 text-[#4A4C56] text-[13px] font-[Poppins]">
                    {item.desc}
                  </div>
                </div>
                <div className="flex border-b border-[#777980]">
                  <div className="w-1/3 p-2 bg-[#0D0D0D] text-white text-[13px] text-center font-[Poppins] border-r border-[#777980]">
                    List
                  </div>
                  <div className="w-2/3 p-2 text-[#4A4C56] text-[13px] font-[Poppins]">
                    {item.list}
                  </div>
                </div>
                <div className="flex">
                  <div className="w-1/3 p-2 bg-[#0D0D0D] text-white text-[13px] text-center font-[Poppins] border-r border-[#777980]">
                    Suggested
                  </div>
                  <div className="w-2/3 p-2 text-[#4A4C56] text-[13px] font-[Poppins]">
                    {item.suggested}
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SoftwareUpgradeTable;
